module.exports = __webpack_public_path__ + "img/file-csv.60cbf309.svg";